export default __webpack_public_path__ + "static/couple-5b6cbf0eda8d46975660bf1aacedeb54.jpg";